export function valueAccessor<T extends Record<string, any>>(
  row: T,
  path: string
): any {
  if (!row || !path) {
    return row;
  }

  if (path.indexOf('.') > -1) {
    const [id, nestedPath] = path.split(/\.(.*)/, 2);

    return valueAccessor(row[id], nestedPath);
  }

  return row[path];
}
